import './index.scss';
import {Typography} from '@customink/pigment-react';
import React, {useEffect, useRef} from 'react';
import usePriceQuote from '../../hooks/queries/quotes';

export default function VolumeDiscountMessage({
  canOrderSingles,
  currentColor,
  discountPercentage
}) {
  const {
    data: minimumQuote,
    error: singleError,
    isLoading: singleLoading
  } = usePriceQuote(currentColor?.legacyColorId, canOrderSingles, 1, 0, true);
  const getMinimumQuote = minimumQuote && Object.values(minimumQuote);
  const minimumQuoteRef = useRef(getMinimumQuote);
  const discountPercentageRef = useRef(discountPercentage);

  useEffect(() => {
    if (getMinimumQuote) {
      minimumQuoteRef.current = getMinimumQuote;
    }
    if (discountPercentage) {
      discountPercentageRef.current = discountPercentage;
    }
  }, [getMinimumQuote, discountPercentage]);

  return (
    <>
      <Typography className="pc-Volume-Discount-Message pc-Volume-Discount-Message-price">
        $
        {singleError || singleLoading
          ? minimumQuoteRef.current
          : getMinimumQuote}{' '}
        each
      </Typography>
      <Typography className="pc-Volume-Discount-Message">
        Saving{' '}
        {singleError || singleLoading || !discountPercentage
          ? discountPercentageRef?.current
          : Math.trunc(discountPercentage)}
        %
      </Typography>
      <Typography className="pc-Volume-Discount-Message pc-Volume-Discount-Message-text">
        with volume discount.
      </Typography>
    </>
  );
}
